// persistent-router.js
// Owns Barba navigation, scroll restoration, and page lifecycle recovery.
// The audio player stays persistent but no longer owns routing.

(function () {
  if (window.__persistentRouterInit) return;
  window.__persistentRouterInit = true;
  window.__persistentRouterOwnsNavigation = true;

  var pendingBarbaScrollToTop = false;
  var pendingBarbaPopRestore = false;
  var pendingBarbaStandardNav = false;
  var activeBarbaNavigationHref = "";
  var activeBarbaNavigationStartedAt = 0;
  var activeBarbaNavigationTimer = null;

  function getNavigationUrl(rawUrl) {
    if (!rawUrl) return null;
    try {
      return new URL(rawUrl, window.location.href);
    } catch (_) {
      return null;
    }
  }

  function getBarbaScrollKey(url) {
    try {
      var absolute = new URL(url, window.location.href);
      absolute.hash = "";
      return "__barbaScroll::" + absolute.href;
    } catch (_) {
      return "__barbaScroll::" + String(url || window.location.href).split("#")[0];
    }
  }

  function storeCurrentScroll(url) {
    try {
      sessionStorage.setItem(
        getBarbaScrollKey(url || window.location.href),
        JSON.stringify({
          x: window.pageXOffset || window.scrollX || 0,
          y: window.pageYOffset || window.scrollY || 0
        })
      );
    } catch (_) {}
  }

  function readStoredScroll(url) {
    try {
      var raw = sessionStorage.getItem(getBarbaScrollKey(url || window.location.href));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.y !== "number") return null;
      return {
        x: typeof parsed.x === "number" ? parsed.x : 0,
        y: parsed.y
      };
    } catch (_) {
      return null;
    }
  }

  function applyScrollPosition(x, y) {
    try {
      window.scrollTo(x, y);
      document.documentElement.scrollLeft = x;
      document.documentElement.scrollTop = y;
      document.body.scrollLeft = x;
      document.body.scrollTop = y;
    } catch (_) {}
  }

  function getViewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function getDocumentScrollHeight() {
    var doc = document.documentElement;
    var body = document.body;
    return Math.max(
      doc ? doc.scrollHeight : 0,
      body ? body.scrollHeight : 0,
      doc ? doc.offsetHeight : 0,
      body ? body.offsetHeight : 0,
      doc ? doc.clientHeight : 0
    );
  }

  function clampScrollToDocument() {
    var currentX = window.pageXOffset || window.scrollX || document.documentElement.scrollLeft || 0;
    var currentY = window.pageYOffset || window.scrollY || document.documentElement.scrollTop || 0;
    var maxY = Math.max(0, getDocumentScrollHeight() - getViewportHeight());
    if (currentY > maxY + 1) {
      applyScrollPosition(currentX, maxY);
    }
  }

  function refreshLayoutMeasurements() {
    try {
      if (window.__themeLenis && typeof window.__themeLenis.resize === "function") {
        window.__themeLenis.resize();
      }
    } catch (_) {}

    try {
      window.dispatchEvent(new CustomEvent("theme:layout-change"));
      document.dispatchEvent(new CustomEvent("theme:layout-change"));
    } catch (_) {}
  }

  function settlePageGeometry() {
    refreshLayoutMeasurements();
    clampScrollToDocument();
    requestAnimationFrame(function () {
      refreshLayoutMeasurements();
      clampScrollToDocument();
      requestAnimationFrame(clampScrollToDocument);
    });
    window.setTimeout(function () {
      refreshLayoutMeasurements();
      clampScrollToDocument();
    }, 120);
    window.setTimeout(clampScrollToDocument, 360);
  }

  window.__persistentRouterSettleGeometry = settlePageGeometry;

  function getBarbaPageUrl(page, fallbackUrl) {
    if (page && page.url && typeof page.url.href === "string" && page.url.href) {
      return page.url.href;
    }
    return fallbackUrl || window.location.href;
  }

  function isSamePageHashLink(url) {
    if (!url || !url.hash) return false;
    return (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    );
  }

  function isCurrentPageNoHashLink(url) {
    if (!url || url.hash) return false;
    return (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    );
  }

  function isModifiedNavigationClick(event) {
    return !!(
      event &&
      (
        (typeof event.button === "number" && event.button !== 0) ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      )
    );
  }

  function isPlaceholderHref(rawHref) {
    var value = String(rawHref || "").trim();
    return !value || value === "#" || /^javascript:/i.test(value);
  }

  function isHeaderMenuNavigationLink(link) {
    if (!link || typeof link.closest !== "function") return false;
    if (!link.closest("[data-h2-menu]")) return false;
    if (link.closest("[data-newsletter-trigger], [data-global-form-trigger]")) return false;
    return !isPlaceholderHref(link.getAttribute("href") || link.href || "");
  }

  function isSecondHeaderNavigationLink(link) {
    if (!link || typeof link.closest !== "function") return false;
    if (!link.closest("[data-sh-root]")) return false;
    if (link.closest("[data-newsletter-trigger], [data-global-form-trigger]")) return false;
    if (link.hasAttribute("data-sh-desktop-toggle")) return false;
    if (link.hasAttribute("data-sh-drawer-parent-link") && !link.hasAttribute("data-sh-drawer-nav")) return false;
    return !isPlaceholderHref(link.getAttribute("href") || link.href || "");
  }

  function isSecondHeaderLink(el) {
    return !!(el && typeof el.closest === "function" && el.closest("[data-sh-root]"));
  }

  function isPersistentHeaderNavigationLink(link) {
    return isHeaderMenuNavigationLink(link) || isSecondHeaderNavigationLink(link);
  }

  function closePersistentMenusForNavigation(link) {
    if (typeof window.__h2CloseMenuForNavigation === "function") {
      try { window.__h2CloseMenuForNavigation(link); } catch (_) {}
    }
    if (typeof window.__shCloseMenuForNavigation === "function") {
      try { window.__shCloseMenuForNavigation(link); } catch (_) {}
    }
  }

  function closestFromTarget(target, selector) {
    if (!target) return null;
    var element = target.nodeType === 1 ? target : target.parentElement;
    if (!element || typeof element.closest !== "function") return null;
    return element.closest(selector);
  }

  function hasActiveBarbaNavigation(url) {
    if (!activeBarbaNavigationHref || !url) return false;
    return activeBarbaNavigationHref === url.href && (Date.now() - activeBarbaNavigationStartedAt) < 4000;
  }

  function markActiveBarbaNavigation(url) {
    activeBarbaNavigationHref = url && url.href ? url.href : "";
    activeBarbaNavigationStartedAt = Date.now();
    if (activeBarbaNavigationTimer) {
      clearTimeout(activeBarbaNavigationTimer);
      activeBarbaNavigationTimer = null;
    }
    activeBarbaNavigationTimer = window.setTimeout(function () {
      activeBarbaNavigationHref = "";
      activeBarbaNavigationStartedAt = 0;
      activeBarbaNavigationTimer = null;
    }, 4000);
  }

  function clearActiveBarbaNavigation() {
    activeBarbaNavigationHref = "";
    activeBarbaNavigationStartedAt = 0;
    if (activeBarbaNavigationTimer) {
      clearTimeout(activeBarbaNavigationTimer);
      activeBarbaNavigationTimer = null;
    }
  }

  function shouldBypassBarbaNavigation(href, el, options) {
    var opts = options || {};
    var ignoreNoBarba = !!opts.ignoreNoBarba;
    var rawHref = href || (el && typeof el.getAttribute === "function" && el.getAttribute("href")) || (el && el.href) || "";
    var url = getNavigationUrl(rawHref);
    if (!url) return true;

    if (el && typeof el.closest === "function") {
      if (el.target === "_blank" || el.hasAttribute("download")) return true;
      if (!ignoreNoBarba && el.closest("[data-no-barba], [data-global-form-trigger]")) return true;
      if (isSecondHeaderLink(el)) return true;
    }

    if (url.origin !== window.location.origin) return true;
    if (isSamePageHashLink(url)) return true;

    return (
      url.pathname.indexOf("/cart") !== -1 ||
      url.pathname.indexOf("/checkout") !== -1 ||
      url.pathname.indexOf("/account") !== -1 ||
      url.pathname.indexOf("/password") !== -1 ||
      url.pathname.indexOf("/policies") !== -1 ||
      /^\/pages\/(?:get-on-the-map-form|host-form|submit-your-film-form|teach-form|perform-form|volunteer-form|fertile-substrate-form|vend-form|invisible-signals-form)(?:\/)?$/i.test(url.pathname)
    );
  }

  function navigateWithPersistentBarba(rawHref, options) {
    var opts = options || {};
    var link = opts.el || null;
    var url = getNavigationUrl(rawHref || (link && (link.getAttribute("href") || link.href)) || "");
    if (!url) return false;

    if (isCurrentPageNoHashLink(url)) {
      closePersistentMenusForNavigation(link);
      return false;
    }

    if (hasActiveBarbaNavigation(url)) return true;

    if (shouldBypassBarbaNavigation(url.href, link, opts)) return false;
    if (!window.barba || typeof window.barba.go !== "function") return false;

    closePersistentMenusForNavigation(link);
    pendingBarbaPopRestore = false;
    pendingBarbaScrollToTop = false;
    pendingBarbaStandardNav = true;
    markActiveBarbaNavigation(url);
    try {
      window.barba.go(url.href);
    } catch (_) {
      clearActiveBarbaNavigation();
      window.location.href = url.href;
    }
    return true;
  }

  window.__persistentBarbaNavigate = navigateWithPersistentBarba;
  window.__persistentShouldBypassBarbaLink = shouldBypassBarbaNavigation;

  function applyPendingScrollReset(targetUrl) {
    var targetX = 0;
    var targetY = 0;
    var shouldApply = false;
    var resolvedUrl = targetUrl || window.location.href;

    if (pendingBarbaPopRestore) {
      var stored = readStoredScroll(resolvedUrl);
      pendingBarbaPopRestore = false;
      if (stored) {
        targetX = stored.x;
        targetY = stored.y;
      }
      shouldApply = true;
    } else if (pendingBarbaScrollToTop || pendingBarbaStandardNav) {
      pendingBarbaScrollToTop = false;
      pendingBarbaStandardNav = false;
      shouldApply = true;
    }

    if (!shouldApply) return;

    applyScrollPosition(targetX, targetY);
    requestAnimationFrame(function () {
      applyScrollPosition(targetX, targetY);
      requestAnimationFrame(function () {
        applyScrollPosition(targetX, targetY);
      });
    });
    window.setTimeout(function () {
      applyScrollPosition(targetX, targetY);
      settlePageGeometry();
    }, 80);
  }

  function dispatchSectionLifecycle(container, eventName, options) {
    if (!container) return;
    var sections = container.querySelectorAll('[id^="shopify-section-"]');
    var legacyOnly = !!(options && options.legacyOnly);
    sections.forEach(function (sectionEl) {
      if (legacyOnly && !sectionEl.querySelector("[data-section-type]")) return;
      var rawId = sectionEl.getAttribute("id") || "";
      var sectionId = rawId.replace(/^shopify-section-/, "");
      if (!sectionId) return;
      try {
        sectionEl.dispatchEvent(new CustomEvent(eventName, {
          bubbles: true,
          detail: { sectionId: sectionId }
        }));
      } catch (_) {}
    });
  }

  function executeContainerScripts(container) {
    if (!container) return;
    var scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach(function (oldScript) {
      if (!oldScript || oldScript.src) return;
      var type = (oldScript.getAttribute("type") || "").trim();
      if (type && type !== "text/javascript" && type !== "application/javascript" && type !== "module") {
        return;
      }
      var newScript = document.createElement("script");
      Array.from(oldScript.attributes || []).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent || "";
      oldScript.replaceWith(newScript);
    });
  }

  function resetTransientUiLayers() {
    document.querySelectorAll(".tooltip").forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    document.querySelectorAll(".gm-modal").forEach(function (modal) {
      modal.classList.remove(
        "is-open",
        "is-closing",
        "is-closing-stage-1",
        "is-closing-stage-2",
        "is-closing-media",
        "is-closing-overlay",
        "is-opening-stage-1",
        "is-opening-overlay",
        "is-opening-media",
        "is-open-steady",
        "is-open-vb"
      );
      modal.hidden = true;
    });
    document.body.classList.remove("gm-lock", "pap-info-scroll-locked");
    document.documentElement.classList.remove("pap-info-scroll-locked");

    document.querySelectorAll(".pswp").forEach(function (el) {
      el.classList.remove(
        "pswp--open",
        "pswp--animate_opacity",
        "pswp--zoom-allowed",
        "pswp--zoomed-in",
        "pswp--dragging",
        "pswp--ui--hidden"
      );
      el.style.display = "none";
    });
  }

  function runRegistry(registryName) {
    var registry = window[registryName];
    if (!registry || typeof registry !== "object") return;
    Object.keys(registry).forEach(function (key) {
      var fn = registry[key];
      try {
        if (typeof fn === "function") fn();
      } catch (_) {}
    });
  }

  function runNavigationRecovery(container) {
    resetTransientUiLayers();

    [
      "__relatedArticlesSliderInitFns",
      "__relatedArticlesSliderMotionInitFns",
      "__fffFilmPageInitFns",
      "__fffHeaderBaseInitFns",
      "__fffRelatedFilmsSliderInitFns",
      "__fffRelatedFilmsSliderMotionInitFns",
      "__ReaderReviewsInitFns",
      "__splitImageHoverInitFns",
      "__splitImageHoverMotionInitFns",
      "__productTemplate9InitFns",
      "__productRecommendationsInitFns",
      "__dsvInitFns",
      "__ddpInitFns",
      "__ArticleShareFloatInitFns",
      "__ArticleHeaderSplitInitFns",
      "__rmcMetaobjectCardsInitFns",
      "__rmcTicketIncludesInitFns",
      "__rmcFeaturedEventCardsInitFns",
      "__fffYearFilmShowcaseInitFns",
      "__FilmAvailabilityListInitFns",
      "__AdvancedContentBackgroundVideoInitFns",
      "__musicAlbumArtistsShowcaseInitFns",
      "__masterBlogGridInitFns",
      "__masterBlogGridMotionInitFns",
      "__fdGridInitFns",
      "__pteInitFns"
    ].forEach(runRegistry);

    try {
      if (window.theme && window.theme.sectionParallax && typeof window.theme.sectionParallax.refresh === "function") {
        window.theme.sectionParallax.refresh(container || document);
      }
    } catch (_) {}

    try {
      if (window.AOS && typeof window.AOS.refreshHard === "function") {
        window.AOS.refreshHard();
      } else if (window.AOS && typeof window.AOS.refresh === "function") {
        window.AOS.refresh();
      }
    } catch (_) {}

    try {
      window.dispatchEvent(new CustomEvent("theme:barba:after-render", { detail: { container: container || null } }));
      document.dispatchEvent(new CustomEvent("theme:page:mounted", { detail: { container: container || document } }));
      window.dispatchEvent(new Event("resize"));
      settlePageGeometry();
    } catch (_) {}
  }

  function bindPersistentBarbaLinkRouting() {
    if (!window.barba || typeof window.barba.go !== "function" || window.__persistentBarbaLinkRoutingBound) return;
    window.__persistentBarbaLinkRoutingBound = true;

    document.addEventListener("click", function (event) {
      if (isModifiedNavigationClick(event)) return;
      var link = closestFromTarget(event.target, "a[href]");
      if (!isPersistentHeaderNavigationLink(link)) return;

      var rawHref = link.getAttribute("href") || link.href || "";
      var currentUrl = getNavigationUrl(rawHref);
      if (currentUrl && isCurrentPageNoHashLink(currentUrl)) {
        closePersistentMenusForNavigation(link);
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
        return;
      }

      if (shouldBypassBarbaNavigation(rawHref, link)) return;

      if (navigateWithPersistentBarba(rawHref, { el: link })) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener("click", function (event) {
      if (isModifiedNavigationClick(event)) return;
      var link = closestFromTarget(event.target, "a[href]");
      if (!link) return;
      if (event.defaultPrevented && !isPersistentHeaderNavigationLink(link)) return;

      var rawHref = link.getAttribute("href") || link.href || "";
      var url = getNavigationUrl(rawHref);
      if (!url) return;

      if (isCurrentPageNoHashLink(url)) {
        closePersistentMenusForNavigation(link);
        event.preventDefault();
        return;
      }

      if (shouldBypassBarbaNavigation(rawHref, link)) return;

      if (navigateWithPersistentBarba(url.href, { el: link })) {
        event.preventDefault();
      }
    });
  }

  function initRouter() {
    if (window.__persistentRouterReady) return;
    window.__persistentRouterReady = true;

    if (typeof window.barba === "undefined") {
      console.warn("Barba.js is not loaded. Persistent router skipped.");
      return;
    }

    try {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (_) {}

    window.addEventListener("popstate", function () {
      pendingBarbaPopRestore = true;
      pendingBarbaStandardNav = false;
      pendingBarbaScrollToTop = false;
    });

    try {
      window.barba.init({
        debug: false,
        prevent: function (data) {
          return shouldBypassBarbaNavigation(data && data.href, data && data.el);
        },
        transitions: [{
          name: "fade",
          leave: function (data) {
            var current = data && data.current;
            storeCurrentScroll(getBarbaPageUrl(current, window.location.href));
            if (!pendingBarbaPopRestore) {
              pendingBarbaStandardNav = true;
            }
            dispatchSectionLifecycle(current && current.container, "shopify:section:unload");
            return new Promise(function (resolve) {
              if (current && current.container) current.container.style.opacity = 0;
              setTimeout(resolve, 500);
            });
          },
          enter: function (data) {
            var next = data && data.next;
            if (next && next.container) {
              next.container.style.opacity = 0;
              executeContainerScripts(next.container);
              dispatchSectionLifecycle(next.container, "shopify:section:load", { legacyOnly: true });
            }
            resetTransientUiLayers();
            applyPendingScrollReset(getBarbaPageUrl(next, window.location.href));
            setTimeout(function () {
              if (!next || !next.container) return;
              next.container.style.transition = "opacity 0.5s ease";
              next.container.style.opacity = 1;
            }, 10);
          }
        }]
      });
    } catch (err) {
      console.warn("barba.init skipped:", err);
    }

    bindPersistentBarbaLinkRouting();

    if (window.barba.hooks && typeof window.barba.hooks.after === "function") {
      window.barba.hooks.after(function (data) {
        var nextContainer = data && data.next && data.next.container;
        clearActiveBarbaNavigation();
        applyPendingScrollReset(getBarbaPageUrl(data && data.next, window.location.href));
        requestAnimationFrame(function () {
          runNavigationRecovery(nextContainer);
          applyPendingScrollReset(getBarbaPageUrl(data && data.next, window.location.href));
          settlePageGeometry();
        });
      });
    }

    window.addEventListener("pageshow", settlePageGeometry);
    window.addEventListener("load", settlePageGeometry);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRouter, { once: true });
  } else {
    initRouter();
  }
})();
